export enum DataConnectorTypesEnum {
    GOOGLE_ANALYTICS = 'GOOGLE_ANALYTICS',
    GOOGLE_ANALYTICS_4 = 'GOOGLE_ANALYTICS_V4',
    TWITTER = 'TWITTER',
    FACEBOOK = 'FACEBOOK',
    LINKEDIN = 'LINKEDIN',
    BLUESKY = 'BLUESKY',
    INSTAGRAM = 'INSTAGRAM',
    TIKTOK = 'TIKTOK',
    YOUTUBE = 'YOUTUBE',
    REDDIT = 'REDDIT',
    EMAIL_ACCOUNT = 'EMAIL_ACCOUNT'
}
